import {useLocation} from 'react-router-dom';
import {useEdges} from '../../features/edges/context/EdgesContext';

const useBreadcrumbs = () => {
  const location = useLocation();
  const {edges} = useEdges();
  const path = location.pathname;

  const breadcrumbs = [
    {name: 'Home', link: '/'}
  ];

  const edgeMatch = path.match(/\/edges\/([^/]+)(?:\/(statistics|configuration|meterreport))?/i);

  if (edgeMatch) {
    const edgeId = edgeMatch[1];
    const page = edgeMatch[2] ? edgeMatch[2].toLowerCase() : 'statistics';

    const edge = edges.find(e => e.id === edgeId);

    // Level 2: Edge
    breadcrumbs.push({
      name: edgeId,
      link: `/edges/${edgeId}/statistics`
    });

    // Level 3: Current Page with Branches
    const branches = [
      {name: 'Statistics', link: `/edges/${edgeId}/statistics`},
      {name: 'Configuration', link: `/edges/${edgeId}/configuration`}
    ];

    if (edge?.meterReport) {
      branches.push({name: 'Meter Report', link: `/edges/${edgeId}/meterreport`});
    }

    const currentPageObj = branches.find(b => path.toLowerCase().endsWith(b.link.split('/').pop().toLowerCase()));
    const displayName = currentPageObj ? currentPageObj.name : (page.charAt(0).toUpperCase() + page.slice(1));

    breadcrumbs.push({
      name: displayName,
      link: null,
      branches: branches
    });
  } else if (path === '/') {
    breadcrumbs[0].link = null;
  }

  return breadcrumbs;
};

export default useBreadcrumbs;
